/**
 * PitchBook Admin API
 * PitchBook Admin OpenAPI specification
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import {createAction} from '@reduxjs/toolkit';
import {ApiMethods, ConcurrentStrategies} from '@pb/middleware-api';
import {PayloadData} from '../types';
import type {Error} from '../models/Error';
import type {GetUserCrmIdsRequest} from '../models/GetUserCrmIdsRequest';
import type {UserCrmIds} from '../models/UserCrmIds';

export interface GetUsersCRMIDsByEmails$Request {
    getUserCrmIdsRequest: GetUserCrmIdsRequest;
}

export interface GetUsersCRMIDsByEmails$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsersCRMIDsByEmailsRequest = createAction<PayloadData<void, GetUsersCRMIDsByEmails$Request>>('GET_USERS_CRM_IDS__GET_USERS_CRMIDS_BY_EMAILS__REQUEST');
export const getUsersCRMIDsByEmailsSuccess = createAction<PayloadData<Array<UserCrmIds>, GetUsersCRMIDsByEmails$Request>>('GET_USERS_CRM_IDS__GET_USERS_CRMIDS_BY_EMAILS__SUCCESS');
export const getUsersCRMIDsByEmailsFailure = createAction<PayloadData<Error, GetUsersCRMIDsByEmails$Request, true>>('GET_USERS_CRM_IDS__GET_USERS_CRMIDS_BY_EMAILS__FAILURE');

export const getUsersCRMIDsByEmailsActions = [
    getUsersCRMIDsByEmailsRequest,
    getUsersCRMIDsByEmailsSuccess,
    getUsersCRMIDsByEmailsFailure
] as const;

/**
 * @param {GetUserCrmIdsRequest} meta.getUserCrmIdsRequest
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsersCRMIDsByEmails = (meta: GetUsersCRMIDsByEmails$Request, config?: GetUsersCRMIDsByEmails$Config) => {
    return {
        CALL_API: {
            types: getUsersCRMIDsByEmailsActions,
            method: ApiMethods.POST,
            endpoint: `/web-api/users/crm-ids`,
            TRANSPORT_REQUEST_BODY: meta.getUserCrmIdsRequest,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

export interface GetUsersCRMIDsByIds$Request {
    requestBody: Array<number>;
}

export interface GetUsersCRMIDsByIds$Config {
    bulk?: boolean;
    concurrentStrategy?: typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies];
    signal?: AbortSignal;
}

export const getUsersCRMIDsByIdsRequest = createAction<PayloadData<void, GetUsersCRMIDsByIds$Request>>('GET_USERS_CRM_IDS__GET_USERS_CRMIDS_BY_IDS__REQUEST');
export const getUsersCRMIDsByIdsSuccess = createAction<PayloadData<{ [key: string]: UserCrmIds; }, GetUsersCRMIDsByIds$Request>>('GET_USERS_CRM_IDS__GET_USERS_CRMIDS_BY_IDS__SUCCESS');
export const getUsersCRMIDsByIdsFailure = createAction<PayloadData<Error, GetUsersCRMIDsByIds$Request, true>>('GET_USERS_CRM_IDS__GET_USERS_CRMIDS_BY_IDS__FAILURE');

export const getUsersCRMIDsByIdsActions = [
    getUsersCRMIDsByIdsRequest,
    getUsersCRMIDsByIdsSuccess,
    getUsersCRMIDsByIdsFailure
] as const;

/**
 * @param {Array<number>} meta.requestBody
 * @param {boolean} [config.bulk]
 * @param {typeof ConcurrentStrategies[keyof typeof ConcurrentStrategies]} [config.concurrentStrategy]
 * @param {AbortSignal} [config.signal]
 */
export const getUsersCRMIDsByIds = (meta: GetUsersCRMIDsByIds$Request, config?: GetUsersCRMIDsByIds$Config) => {
    return {
        CALL_API: {
            types: getUsersCRMIDsByIdsActions,
            method: ApiMethods.PUT,
            endpoint: `/web-api/users/crm-ids`,
            TRANSPORT_REQUEST_BODY: meta.requestBody,
            bulk: config?.bulk,
            concurrentStrategy: config?.concurrentStrategy,
            signal: config?.signal,
            headers: {
                'Content-Type': 'application/json',
                'Accept': 'application/json',
            }
        },
        ...meta
    }
};

